<button id="upload_error__retake_button" (click)="retakeInterview()">
  {{
    "record_interview.recorder.upload_error.button.retake_interview" | transloco
  }}
</button>
